import React from 'react';
import '../../styles/RateCard.css';

const LandingPages = () => {
    return (
        <section className="landing-pages-section py-5">
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Landing<br /><span className="highlight-bg">Pages</span>
                        </h2>
                        <p className="mt-4">
                            Las landing pages de BeHealth están diseñadas estratégicamente para maximizar
                            la conversión en campañas específicas. Ideales para destacar días mundiales,
                            eventos y ferias de salud, estas páginas ofrecen un espacio exclusivo donde
                            tu marca puede conectarse directamente con audiencias relevantes, garantizando
                            una experiencia de usuario optimizada y resultados efectivos.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Diseño personalizado y orientado a objetivos de conversión.</li>
                            <li>Integración con campañas específicas para un mayor impacto.</li>
                            <li>Espacios publicitarios exclusivos dentro de la página.</li>
                            <li>Promoción y tráfico dirigido desde los canales de BeHealth.</li>
                            <li>Estadísticas y métricas detalladas para medir resultados.</li>
                        </ul>
                        <div className="tab-label mt-4">Desarrollo Ad Hoc + Contenido</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Permanencia:</h4>
                            <p className="">
                                Las landing pages están disponibles x 1 año con opción a renovación.
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Espacios publicitarios exclusivos.</li>
                                    <li>Promoción en redes sociales y newsletter.</li>
                                    <li>Estadísticas detalladas sobre el rendimiento de la página.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión:</strong><br />
                                A cotizar x micrositio disponible x un año.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default LandingPages;
